module.exports = __webpack_public_path__ + "static/media/warning.d23457e7.svg";